import { render } from "./Banners.vue?vue&type=template&id=53955c44&scoped=true"
import script from "./Banners.vue?vue&type=script&lang=js"
export * from "./Banners.vue?vue&type=script&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=53955c44&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53955c44"]])

export default __exports__